import SearchUserMemberModalPresenter from "./SearchUserMemberModalPresenter";

export const SearchUserMemberModal = SearchUserMemberModalPresenter;

export default SearchUserMemberModal;